<script>
import { Doughnut } from 'vue-chartjs'

export default {
  extends: Doughnut,

  props: {
    chartData: {
      type: Object,
      default: null
    },
    year: String
  },

  computed: {
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
          mode: 'index'
        }
      }
    },
  },

  mounted () {
    const localChartData = this.chartData

    const colors = []

    this.chartData.labels.forEach(() => {
      colors.push(`rgb(${this.getRandomColor()}, ${this.getRandomColor()}, ${this.getRandomColor()})`)
    })

    if (localChartData.datasets) {
      if (localChartData.datasets.length) {
        localChartData.datasets[0].backgroundColor = colors
      }
    }

    this.renderChart(localChartData, this.chartOptions)
  },

  methods: {
    getRandomColor: () => {
      return Math.floor(Math.random() * (235 - 52 + 1) + 52)
    }
  }
}
</script>
